import { settings } from '../../engine/settings-sidecar'
import { websockets } from '../../engine/websockets-sidecar'
import { l } from '../../lib/imports'
import { createId } from '../../main/common'
import { EVoyageMissionType } from './missions/voyageMissionData'
import { voyageMessageBuyRequest } from './multi/voyageMessageBuyRequest-sidecar'
import { EVoyageCrewCreateMethod } from './multi/voyageMessageCrewCreate'
import { voyageMessageCrewCreate } from './multi/voyageMessageCrewCreate-sidecar'
import { EVoyageCarryableType } from './voyageCarryableData'
import { EVoyageCrewType } from './voyageCrew'
import { voyageGameManager } from './voyageGameManager-sidecar'
import { voyageGameMode_tutorial } from './voyageGameMode_tutorial-sidecar'
import { voyageGameStatus } from './voyageGameStatus-sidecar'
import { voyageSaver } from './voyageSaver-sidecar'
import { voyageTestParams } from './voyageTestParams-sidecar'
import { voyageTilemap } from './voyageTilemap-sidecar'
import { voyageToolBodyAlign } from './voyageToolBodyAlign-sidecar'
import { EBuyType } from './voyageUiBuyStuff_data'

const namespace = 'voyage-loading'

export function* generator_loading(): Generator<number, number, number> {
  console.log(namespace, 'loading game!!')

  voyageToolBodyAlign.doLoad()
  while (!voyageToolBodyAlign.getIsLoaded()) {
    yield 0
  }

  let startingShip = 'small' // 'voyage

  if (!voyageTestParams.isDevMode) {
    voyageSaver.load(startingShip)
    voyageGameManager.goMenuMain()
  } else {
    let tm = voyageTestParams.loadTestMode()

    voyageSaver.load(settings.get().filename || startingShip)

    if (tm === 'editor') {
      voyageGameManager.goEditor()
    } else if (tm === 'game') {
      websockets.setSingleplayer(true)
      voyageGameManager.goGame()
      voyageGameMode_tutorial.signalSkip(true)
    } else if (tm === 'body-align') {
      voyageGameManager.goBodyAlign()
    } else if (tm === 'test') {
      websockets.setSingleplayer(true)
      voyageGameManager.goGame()
      voyageGameMode_tutorial.signalSkip(true)

      voyageGameManager.addAfterLoad(() => {
        voyageGameStatus.setMission(EVoyageMissionType.Test1)
        voyageGameStatus.setMission(EVoyageMissionType.FightAliens2)
      })
      // TODO: load test mission
    } else {
      if (voyageTestParams.singleplayerAutoJoin) {
        websockets.setSingleplayer(true)
        voyageGameManager.goGame()
        voyageGameMode_tutorial.signalSkip(true)
      } else {
        voyageGameManager.goMenuMain()
      }
    }
  }

  return 0
}
